if (!customElements.get('fade-image-mosaic')) {
  class FadeImageMosaic extends HTMLElement {
    connectedCallback() {
      if (this.classList.contains('fim--fade')) this._initFade();
    }

    _initFade() {
      const cards = Array.from(this.querySelectorAll('.fim__card-wrap'));

      const io = new IntersectionObserver(entries => {
        entries.forEach(e => e.target.classList.toggle('is-visible', e.isIntersecting));
      }, { threshold: 0.08 });

      cards.forEach((card, i) => {
        card.style.transitionDelay = `${i * 60}ms`;
        card.classList.add('fim--fade-item');
        io.observe(card);
      });
    }
  }

  customElements.define('fade-image-mosaic', FadeImageMosaic);
}
